import { render, staticRenderFns } from "./BetStatusIcon.vue?vue&type=template&id=4e8108cc"
import script from "./BetStatusIcon.vue?vue&type=script&lang=ts"
export * from "./BetStatusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports